import React from 'react'
import s from '../../css/profile/profileInfo.module.css'
import { FaRegCopy } from 'react-icons/fa'
import { IoCheckmarkDoneSharp } from 'react-icons/io5'

const ProfileInfo = ({
	email,
	apikey,
	checkboxMailing,
	isChecked,
	copyApiKey,
	isCopied,
}) => {
	return (
		<>
			<section className={s.account}>
				<h3>Аккаунт</h3>
				<div className={s.field}>
					<span className={s.label}>Email</span>
					<p className={s.email}>{email}</p>
				</div>
				<div className={`${s.field} ${s.mailing}`}>
					<p>Получать рассылку об обновлениях</p>
					<div>
						<input
							type='checkbox'
							id={s.checkbox}
							onChange={e => checkboxMailing(e)}
							defaultChecked={isChecked}
						/>
						<label htmlFor={s.checkbox} className={s.custom__checkbox}></label>
					</div>
				</div>
			</section>
			<section className={s.keyCard}>
				<h3>API-KEY</h3>
				<div className={s.apikey}>
					<code className={s.key}>{apikey}</code>
					{isCopied ? (
						<button className={`${s.copy} ${s.copied}`}>
							<IoCheckmarkDoneSharp />
							Скопировано
						</button>
					) : (
						<button className={s.copy} onClick={copyApiKey}>
							<FaRegCopy />
							Копировать
						</button>
					)}
				</div>
			</section>
		</>
	)
}

export default ProfileInfo
